import { admin, user } from "../axios";

export const getUserId = async (email: string) => {
  const response = await user.get(`users?search=${email}`);
  return response;
};
